import { Tabs } from 'antd';

import { ANALYTICS } from '@app/constants';
import { useAnalyticsLayout } from '@app/pages/Analytics/AnalyticsLayout/hooks';

export const AnalyticsLayout = () => {
  const { activeTab, onTabChange, analyticsTabs } = useAnalyticsLayout();

  return (
    <div className="analytics-layout">
      <Tabs
        activeKey={activeTab || ANALYTICS}
        onChange={onTabChange}
        type="card"
        size="middle"
        style={{ marginBottom: 32 }}
        items={analyticsTabs}
      />
    </div>
  );
};
